/**
 * @flow
 * @relayHash 4129b9117eae928d7a790e568ddc62e1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchRateLimitReason = "DAILY_MAX" | "FIVE_MINUTE_MAX" | "NONE" | "ONE_MINUTE_MAX" | "%future added value";
export type LogSearchInput = {|
  userIdGlobal?: ?string,
  userId?: ?string,
  anonUserId?: ?string,
  source?: ?string,
  causeId?: ?string,
  searchEngineId?: ?string,
  version?: ?number,
  clientMutationId?: ?string,
|};
export type LogSearchMutationVariables = {|
  input: LogSearchInput
|};
export type LogSearchMutationResponse = {|
  +logSearch: ?{|
    +user: ?{|
      +id: string,
      +heartsUntilNextLevel: ?number,
      +level: ?number,
      +searches: ?number,
      +searchRateLimit: ?{|
        +limitReached: ?boolean,
        +reason: ?SearchRateLimitReason,
      |},
      +searchesToday: ?number,
      +vcCurrent: ?number,
      +vcAllTime: ?number,
    |}
  |}
|};
export type LogSearchMutation = {|
  variables: LogSearchMutationVariables,
  response: LogSearchMutationResponse,
|};
*/


/*
mutation LogSearchMutation(
  $input: LogSearchInput!
) {
  logSearch(input: $input) {
    user {
      id
      heartsUntilNextLevel
      level
      searches
      searchRateLimit {
        limitReached
        reason
      }
      searchesToday
      vcCurrent
      vcAllTime
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogSearchInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logSearch",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogSearchPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "heartsUntilNextLevel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "level",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "searches",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchRateLimit",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchRateLimit",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "limitReached",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "reason",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "searchesToday",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcCurrent",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcAllTime",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogSearchMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogSearchMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogSearchMutation",
    "id": null,
    "text": "mutation LogSearchMutation(\n  $input: LogSearchInput!\n) {\n  logSearch(input: $input) {\n    user {\n      id\n      heartsUntilNextLevel\n      level\n      searches\n      searchRateLimit {\n        limitReached\n        reason\n      }\n      searchesToday\n      vcCurrent\n      vcAllTime\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c90d78f758816f9aa45b6c6f643cc33b';
module.exports = node;
